export default {
    install(Vue) {
        // Assign a unique id to each component
        let uidCounter = 0;
        Vue.mixin({
            beforeCreate() {
                uidCounter += 1;
                Object.defineProperties(this, {
                    pgbaUid: {
                        get() {
                            const namePrefix = (this.$options && this.$options.name) ? this.$options.name + '-' : '';
                            return `${namePrefix}${uidCounter}`;
                        }
                    }
                });
            }
        });
        Vue.prototype.$id = function(id = '') {
            return `${this.pgbaUid}-${id}`;
        };
    }
};
